module.exports = __webpack_public_path__ + "static/media/clip_image_step3.851c6dc9.svg";